// Quick fix for college authentication issues
// Run this in the browser console or call from a component

import { supabase } from '../lib/supabase';
import { collegeJourneyService } from '../lib/college-journey-service';

export const fixCollegeAuthentication = async () => {
  console.log('🔧 Starting college authentication fix...');
  
  try {
    // Step 1: Get current Supabase session
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    
    if (sessionError) {
      console.error('❌ Session error:', sessionError);
      return { success: false, error: sessionError.message };
    }
    
    if (!session?.user?.id) {
      console.error('❌ No authenticated user found');
      return { success: false, error: 'No authenticated user' };
    }
    
    console.log('✅ Found authenticated user:', session.user.id);
    console.log('📧 User email:', session.user.email);
    
    // Step 2: Check if user is in family_members
    const { data: familyMember, error: memberError } = await supabase
      .from('family_members')
      .select('*')
      .eq('auth_user_id', session.user.id)
      .maybeSingle();
    
    if (memberError) {
      console.error('❌ Error checking family membership:', memberError);
      return { success: false, error: memberError.message };
    }
    
    if (familyMember) {
      console.log('✅ User already in family_members:', familyMember.name);
      
      // Test college access
      const colleges = await collegeJourneyService.getColleges(session.user.id);
      console.log('📚 College access test:', colleges?.length || 0, 'colleges accessible');
      
      return { 
        success: true, 
        alreadyFixed: true,
        message: `User already in family. ${colleges?.length || 0} colleges accessible.`,
        collegeCount: colleges?.length || 0
      };
    }
    
    // Step 3: Add user to family_members (single family architecture)
    console.log('🔧 Adding user to family_members...');
    
    const { data: newMember, error: insertError } = await supabase
      .from('family_members')
      .insert({
        name: session.user.email || 'Auto-added User',
        auth_user_id: session.user.id,
        role: 'parent',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      })
      .select()
      .single();
    
    if (insertError) {
      console.error('❌ Error adding to family:', insertError);
      return { success: false, error: insertError.message };
    }
    
    console.log('✅ Successfully added user to family:', newMember);
    
    // Step 4: Test college access
    const colleges = await collegeJourneyService.getColleges(session.user.id);
    console.log('📚 College access after fix:', colleges?.length || 0, 'colleges accessible');
    
    // Step 5: Test assessment responses
    const assessmentResponses = await collegeJourneyService.getSavedAssessmentResponses(session.user.id);
    console.log('📝 Assessment responses accessible:', !!assessmentResponses);
    
    return {
      success: true,
      fixed: true,
      message: `User added to family. ${colleges?.length || 0} colleges now accessible.`,
      newMember,
      collegeCount: colleges?.length || 0,
      hasAssessmentData: !!assessmentResponses
    };
    
  } catch (error) {
    console.error('❌ Unexpected error:', error);
    return { success: false, error: error.message };
  }
};

// Browser console function
window.fixCollegeAuth = fixCollegeAuthentication;

export default fixCollegeAuthentication;